(() => {
  "use strict";

  function prepare(root) {
    if (!root || root.dataset.yi2cLoaderReady === "true") return;
    root.dataset.yi2cLoaderReady = "true";
    import(root.dataset.yi2cBuilderScript).then(() => {
      window.__yi2cInitialiseAllBuilders?.(root.parentNode || document);
    }).catch(() => {
      root.dataset.yi2cLoaderReady = "false";
      const status = root.querySelector("[data-upload-status]");
      if (status) status.textContent = "The photo tool could not load. Please refresh and try again.";
    });
  }

  function prepareAll(scope = document) {
    scope.querySelectorAll?.("[data-yi2c-builder]").forEach(prepare);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => prepareAll(), { once: true });
  } else {
    prepareAll();
  }
  if (!window.__yi2cLoaderSectionListenerReady) {
    window.__yi2cLoaderSectionListenerReady = true;
    document.addEventListener("shopify:section:load", (event) => prepareAll(event.target || document));
  }
})();
/* YI2C_STOREFRONT_CRITICAL_ASSET: protected synchronous loader */
